export enum MessageEventsNameE {
  DELETE = 'delete',
  TRANSCRIPTION = 'transcription',
  CANCEL = 'cancel',
}
